import * as React from 'react';
import { Grid } from '@mui/material';

import {
  BuildingTree,
  ChartTotalScans,
  ChartRatingSummary,
  ChartTotalFeedbackReceived,
  ChartCategoryRatingExtremes,
  ChartAreaRatingExtremes,
  ChartCleaningHistory,
} from 'components';
import { useDashboardPageContext } from './dashboard-page.context';
import { DashboardDateRangePicker } from './dashboard-date-range-picker';
import { EZoneScanType } from 'enums';
import { IBuilding } from 'models';
import { VisualizationProvider } from './visualization.context';

interface DashboardCardsProps {
  building: IBuilding;
}

export const DashboardCards: React.FC<DashboardCardsProps> = ({ building }) => {
  const { buildingId, start, end } = useDashboardPageContext();

  return buildingId && start && end ? (
    <Grid container spacing={2}>
      <Grid item container spacing={2}>
        <Grid item sm={12} md={5}>
          <VisualizationProvider buildingId={buildingId}>
            <BuildingTree />
          </VisualizationProvider>
        </Grid>
        <Grid sm={12} md={7} item container alignContent={'flex-start'}>
          <Grid spacing={2} container item>
            <Grid item xs={12} md={11}>
              <DashboardDateRangePicker start={start} end={end} />
            </Grid>
            <Grid item xs={12} md={6}>
              <ChartTotalScans
                buildingId={buildingId}
                start={start}
                end={end}
                type={EZoneScanType.ENGAGEMENT}
                title="Total Engagement Scans"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <ChartTotalFeedbackReceived buildingId={buildingId} start={start} end={end} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <ChartRatingSummary building={building} start={start} end={end} />
      </Grid>
      <Grid item xs={12} md={6}>
        <ChartCategoryRatingExtremes buildingId={buildingId} start={start} end={end} />
      </Grid>
      <Grid item xs={12} md={6}>
        <ChartAreaRatingExtremes buildingId={buildingId} start={start} end={end} />
      </Grid>
      <Grid item xs={12}>
        <ChartCleaningHistory buildingId={buildingId} start={start} end={end} />
      </Grid>
    </Grid>
  ) : null;
};
